import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import { setDataAuthority } from '@/api/authority';
export default {
  name: 'Datas',
  data: function data() {
    return {
      authoritys: [],
      dataAuthorityId: [],
      needConfirm: false,
      selection: "all"
    };
  },
  props: {
    row: {
      default: function _default() {
        return {};
      },
      type: Object
    },
    authority: {
      default: function _default() {
        return {};
      },
      type: Array
    }
  },
  computed: {
    state: function state() {
      var state = "all";
      if (this.dataAuthorityId.length === this.authoritys.length) {
        state = this.selection;
      } else if (this.dataAuthorityId.length === 1) {
        if (this.selection === "children") state = "children";else state = "self";
      } else {
        state = "chilren";
      }
      return state;
    }
  },
  methods: {
    // 暴露给外层使用的切换拦截统一方法
    enterAndNext: function enterAndNext() {
      this.authDataEnter();
    },
    all: function all() {
      this.dataAuthorityId = _toConsumableArray(this.authoritys);
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
      this.selection = "all";
    },
    self: function self() {
      var _this = this;
      this.dataAuthorityId = this.authoritys.filter(function (item) {
        return item.authorityId === _this.row.authorityId;
      });
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
      this.selection = "self";
    },
    selfAndChildren: function selfAndChildren() {
      var arrBox = [];
      this.getChildrenId(this.row, arrBox);
      this.dataAuthorityId = this.authoritys.filter(function (item) {
        return arrBox.indexOf(item.authorityId) > -1;
      });
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
      this.selection = "children";
    },
    getChildrenId: function getChildrenId(row, arrBox) {
      var _this2 = this;
      arrBox.push(row.authorityId);
      row.children && row.children.map(function (item) {
        _this2.getChildrenId(item, arrBox);
      });
    },
    // 提交
    authDataEnter: function () {
      var _authDataEnter = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return setDataAuthority(this.row);
            case 1:
              res = _context.sent;
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('commont.success')
                });
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function authDataEnter() {
        return _authDataEnter.apply(this, arguments);
      }
      return authDataEnter;
    }(),
    //   平铺角色
    roundAuthority: function roundAuthority(authoritys) {
      var _this3 = this;
      authoritys && authoritys.map(function (item) {
        var obj = {};
        obj.authorityId = item.authorityId;
        obj.authorityName = item.authorityName;
        _this3.authoritys.push(obj);
        if (item.children && item.children.length) {
          _this3.roundAuthority(item.children);
        }
      });
    },
    //   选择
    selectAuthority: function selectAuthority() {
      this.row.dataAuthorityId = this.dataAuthorityId;
      this.needConfirm = true;
    }
  },
  created: function created() {
    var _this4 = this;
    this.authoritys = [];
    this.dataAuthorityId = [];
    this.roundAuthority(this.authority);
    this.row.dataAuthorityId && this.row.dataAuthorityId.map(function (item) {
      var obj = _this4.authoritys && _this4.authoritys.filter(function (au) {
        return au.authorityId === item.authorityId;
      }) && _this4.authoritys.filter(function (au) {
        return au.authorityId === item.authorityId;
      })[0];
      _this4.dataAuthorityId.push(obj);
    });
  }
};